export default __webpack_public_path__ + "static/media/February2023.935f11d0.png";